import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Spinner$1 from '../../basics/Spinner/Spinner.js';
import Button$1 from '../../basics/Button/Button.js';
import Grid$1 from '../Grid/Grid.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledTeaserContainer from './TeaserContainer.style.js';

const TeaserContainer = ({
  children,
  onLoadMore,
  entriesCount,
  loading,
  filtering,
  showFilter,
  loadMoreLabel,
  resetLabel,
  onReset,
  noEntriesLabel
}) => /*#__PURE__*/React$1.createElement(StyledTeaserContainer, {
  filtering: filtering
}, filtering && /*#__PURE__*/React$1.createElement(Spinner$1, {
  className: "teaserContainer__spinner",
  size: "large"
}), children && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Grid$1, {
  className: "teaserContainer__wrapper"
}, children, typeof entriesCount === 'number' && entriesCount === 0 && showFilter ? /*#__PURE__*/React$1.createElement("div", {
  className: "teaserContainer__no-results"
}, /*#__PURE__*/React$1.createElement(Typography$1, null, noEntriesLabel), onReset && /*#__PURE__*/React$1.createElement(Button$1, {
  onClick: onReset
}, resetLabel)) : null), onLoadMore && /*#__PURE__*/React$1.createElement("div", {
  className: "teaserContainer__load-more"
}, /*#__PURE__*/React$1.createElement(Button$1, {
  onClick: onLoadMore,
  loading: loading
}, loadMoreLabel))));

TeaserContainer.propTypes = {
  children: PropTypes$1.node,
  onLoadMore: PropTypes$1.func,
  loading: PropTypes$1.bool,
  filtering: PropTypes$1.bool,
  showFilter: PropTypes$1.bool,
  loadMoreLabel: PropTypes$1.string,
  entriesCount: PropTypes$1.number,
  resetLabel: PropTypes$1.string,
  noEntriesLabel: PropTypes$1.string,
  onReset: PropTypes$1.func
};
TeaserContainer.defaultProps = {
  children: null,
  onLoadMore: undefined,
  loading: false,
  filtering: false,
  showFilter: false,
  entriesCount: undefined,
  loadMoreLabel: 'Load more',
  noEntriesLabel: 'No Entries found',
  resetLabel: 'Reset filter',
  onReset: undefined
};

export default TeaserContainer;
